(() => {
  const hideKlaviyoWidgetHeading = (root = document) => {
    const wrappers = [];

    if (root.matches?.('#klaviyo-product-reviews-wrapper')) wrappers.push(root);
    root.querySelectorAll?.('#klaviyo-product-reviews-wrapper').forEach((wrapper) => wrappers.push(wrapper));

    wrappers.forEach((wrapper) => {
      wrapper.querySelectorAll('h1, h2, h3, h4, h5, h6, [role="heading"]').forEach((heading) => {
        if (heading.textContent.trim().toLowerCase() === 'customer reviews') {
          heading.classList.add('kl_reviews__chrysostomos-hidden-heading');
        }
      });
    });
  };

  const enhanceKlaviyoRatingLines = (root = document) => {
    const ratingLines = [];

    if (root.matches?.('[data-klaviyo-rating-line]')) ratingLines.push(root);
    root.querySelectorAll?.('[data-klaviyo-rating-line]').forEach((line) => ratingLines.push(line));

    ratingLines.forEach((ratingLine) => {
      const button = ratingLine.querySelector('.kl_reviews__star_rating_widget');
      const stars = button?.querySelector('.kl_reviews__stars_badge');
      const label = button?.querySelector('.kl_reviews__star_rating_widget__label');
      const ratingData = button?.getAttribute('aria-label')?.match(/([\d.,]+)\s+stars?,\s*([\d,]+)\s+ratings?/i);

      ratingLine.hidden = true;
      if (!button || !stars || !label || !ratingData) return;

      const rating = Number.parseFloat(ratingData[1].replace(',', '.'));
      const count = Number.parseInt(ratingData[2].replace(/,/g, ''), 10);
      if (!Number.isFinite(rating) || !Number.isFinite(count) || rating <= 0 || count <= 0) return;

      const signature = `${rating}:${count}`;
      if (button.dataset.chrysostomosRatingSignature === signature) {
        ratingLine.hidden = false;
        return;
      }

      let visualStars = button.querySelector('.kl_reviews__chrysostomos-stars');
      if (!visualStars) {
        visualStars = document.createElement('span');
        visualStars.className = 'kl_reviews__chrysostomos-stars';
        visualStars.setAttribute('aria-hidden', 'true');
        stars.insertAdjacentElement('beforebegin', visualStars);
      }

      let ratingValue = button.querySelector('.kl_reviews__rating-value');
      if (!ratingValue) {
        ratingValue = document.createElement('strong');
        ratingValue.className = 'kl_reviews__rating-value';
        stars.insertAdjacentElement('afterend', ratingValue);
      }

      let separator = button.querySelector('.kl_reviews__rating-separator');
      if (!separator) {
        separator = document.createElement('span');
        separator.className = 'kl_reviews__rating-separator';
        separator.setAttribute('aria-hidden', 'true');
        ratingValue.insertAdjacentElement('afterend', separator);
      }

      const formattedRating = Number.isInteger(rating) ? rating.toFixed(0) : rating.toFixed(1);
      const formattedCount = new Intl.NumberFormat(document.documentElement.lang || 'en').format(count);
      const customerTextTemplate = ratingLine.dataset.customerText || 'Loved by {count} customers';
      const customerText = customerTextTemplate.includes('{count}')
        ? customerTextTemplate.replace('{count}', formattedCount)
        : `Loved by ${formattedCount} ${count === 1 ? 'customer' : 'customers'}`;

      visualStars.textContent = '★★★★★';
      ratingValue.textContent = `${formattedRating}/5`;
      separator.textContent = '•';
      label.textContent = customerText.replace(/\bcustomers\b/i, count === 1 ? 'customer' : 'customers');
      button.dataset.chrysostomosRatingSignature = signature;
      ratingLine.hidden = false;
    });
  };

  enhanceKlaviyoRatingLines();
  hideKlaviyoWidgetHeading();

  const observer = new MutationObserver((mutations) => {
    hideKlaviyoWidgetHeading();

    for (const mutation of mutations) {
      const target = mutation.target.nodeType === Node.ELEMENT_NODE ? mutation.target : mutation.target.parentElement;
      const ratingLine = target?.closest?.('[data-klaviyo-rating-line]');
      if (ratingLine) {
        enhanceKlaviyoRatingLines(ratingLine);
        return;
      }

      for (const node of mutation.addedNodes) {
        if (node.nodeType !== Node.ELEMENT_NODE) continue;
        if (
          node.matches?.('[data-klaviyo-rating-line], [data-klaviyo-rating-line] *')
          || node.querySelector?.('[data-klaviyo-rating-line]')
        ) {
          enhanceKlaviyoRatingLines(node.closest?.('[data-klaviyo-rating-line]') || node);
          return;
        }
      }
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-label'],
  });

  document.addEventListener('shopify:section:load', (event) => {
    enhanceKlaviyoRatingLines(event.target);
    hideKlaviyoWidgetHeading(event.target);
  });
})();
